export function findParentByAttribute(node, attribute) {
    while ((node = node.parentElement) && !node.getAttribute(attribute));
    return node;
}
